/** Values for the four placeholders docs-gen leaves in every snippet template. */
export interface SnippetValues {
  baseUrl: string;
  apiKey: string;
  customerToken: string;
  idempotencyKey: string;
}

const PLACEHOLDER = /\{\{(baseUrl|apiKey|customerToken|idempotencyKey)\}\}/g;

/**
 * Fills `{{baseUrl}}`, `{{apiKey}}`, `{{customerToken}}` and `{{idempotencyKey}}`. Anything else
 * in the template (path values like `<token>`) is left for the reader to replace.
 */
export function fillSnippet(template: string, values: SnippetValues): string {
  return template.replace(PLACEHOLDER, (_, name: keyof SnippetValues) => values[name]);
}
